import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
} from 'beyond-util';
import { BrendoviComponent } from './brendovi.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [BrendoviComponent],
  entryComponents: [BrendoviComponent],
  exports: [BrendoviComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    NgxSpinnerModule,
  ],
})
export class BrendoviModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/brendovi/brendovi.module.ts